import { HTMLAttributes, ReactElement } from 'react'
import { Box } from '@mui/material'

type Props = HTMLAttributes<HTMLDivElement> & {
  isStreaming?: boolean
  hasContent?: boolean
}

/**
 * The model's reasoning, as plain text. CopilotKit renders it as markdown
 * without the answer's element overrides, so an image the reasoning repeats
 * (e.g. from planted project data) would be fetched without a click (see
 * BlockedMedia). Plain text loads nothing.
 */
const ReasoningContent = ({ isStreaming, hasContent, children }: Props): ReactElement | null => {
  if (!hasContent && !isStreaming) return null
  return (
    <Box
      sx={{
        pb: 1,
        pt: 0.5,
        typography: 'body2',
        color: 'text.secondary',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
      }}
    >
      {typeof children === 'string' ? children : ''}
    </Box>
  )
}

export default ReasoningContent
